const SHORT_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function parseDateParts(value: string): { year: number; month: number; day: number } | null {
  const trimmed = value.trim();
  const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);

    if (
      Number.isInteger(year) &&
      Number.isInteger(month) &&
      Number.isInteger(day) &&
      month >= 1 &&
      month <= 12 &&
      day >= 1 &&
      day <= 31
    ) {
      return { year, month, day };
    }
  }
  return null;
}

export function formatDateToShortString(dateString: string): string {
  const parts = parseDateParts(dateString);
  if (!parts) {
    return dateString;
  }

  return `${parts.day} ${SHORT_MONTHS[parts.month - 1]} ${parts.year}`;
}
